// React
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import ProductAvailabilityCalendar from 'store/modules/product/components/ProductAvailabilityCalendar'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import { getOperatingRules } from 'shared/utils/operating_rules'
import { hasVariations, hasVariationSelected, isValidBundleVariations } from 'shop-components/utils/variations'
import { fetchItem } from 'shop-components/redux/actions/item'

const AvailabilityCalendar = ({ itemId, productId, cart, configuration, locations, availabilities, operatingRules, showCounts, fetchItem }) => {
  useEffect(() => {
    fetchItem()
  }, [productId])

  return (
    <ProductAvailabilityCalendar
      id={itemId}
      productConfiguration={{ products: configuration }}
      currentMonth={cart?.starts_at ? new Date(cart.starts_at) : new Date()}
      availabilities={availabilities}
      defaultLocationId={locations.start?.id}
      operatingRules={operatingRules}
      showCounts={showCounts}
      selected={{ from: cart?.starts_at, to: cart?.stops_at }}
      useBusinessHours
    />
  )
}

AvailabilityCalendar.propTypes = {
  itemId: PropTypes.string,
  productId: PropTypes.string,
  item: PropTypes.object,
  cart: PropTypes.object,
  configuration: PropTypes.object,
  locations: PropTypes.object,
  availabilities: PropTypes.object,
  operatingRules: PropTypes.object,
  showCounts: PropTypes.bool,
  fetchItem: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId || window.booqableOptions.cart.id)
  const locations = {
    start: state.orm.locations.getById(cart?.start_location_id ?? window.booqableOptions.cart.startLocationId),
    stop: state.orm.locations.getById(cart?.stop_location_id ?? window.booqableOptions.cart.stopLocationId)
  }

  const item = state.items.records[props.productId]
  let itemId = item?.variation_id
  itemId ||= item?.type === 'product_groups' ? item?.products?.[0]?.id : item?.id

  const availabilities = state.orm.shop_availabilities.getAll({
    item_id: itemId
  })

  const configuration = item?.configuration

  const operatingRules = getOperatingRules(state)
  const showVariantAvailability = () => {
    if (!hasVariations(item)) return true

    if (item?.type === 'bundles') return isValidBundleVariations(item)

    return hasVariationSelected(item)
  }
  const showCounts = !state.settings.get('store.hide_product_availability_quantities') && showVariantAvailability()

  return {
    item,
    itemId,
    configuration,
    cart,
    locations,
    availabilities,
    operatingRules,
    showCounts
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  fetchItem: () => dispatch(fetchItem(props.productId))
})

const decoratedComponent = compose(withStore, withTheme, reduxConnect(mapStateToProps, mapDispatchToProps))(AvailabilityCalendar)

registerCustomElement('bq-product-availability-calendar', decoratedComponent, {
  attributes: ['product-id'],
  mountElement: 'span',
  styleSheetTarget: document.head
})

export default decoratedComponent
